module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'vsauv9s8',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
